/* ==========================================================================
   flux-mededelingen — de meldingen in de balk boven de header wisselen elkaar
   af.

   De meldingen liggen op elkaar in één rastervak (section-flux-mededelingen.css);
   dit element zet alleen data-actief op de juiste. Zonder JavaScript blijft de
   eerste staan, en dat is een geldige toestand.

   Het wisselen stopt zolang de bezoeker met de muis of het toetsenbord in de
   balk zit — anders verdwijnt een link onder je cursor vandaan — en zolang het
   tabblad op de achtergrond staat.
   ========================================================================== */

class FluxMededelingen extends HTMLElement {
  connectedCallback() {
    this.meldingen = [...this.querySelectorAll('[data-melding]')];
    if (this.meldingen.length < 2) return;

    this.huidige = Math.max(0, this.meldingen.findIndex((m) => m.hasAttribute('data-actief')));
    this.interval = Number(this.dataset.interval) || 5000;
    this.gepauzeerd = false;

    for (const gebeurtenis of ['pointerenter', 'focusin']) {
      this.addEventListener(gebeurtenis, () => this.pauzeer(true));
    }
    for (const gebeurtenis of ['pointerleave', 'focusout']) {
      this.addEventListener(gebeurtenis, () => this.pauzeer(false));
    }
    this.zichtbaarheid = () => this.pauzeer(document.hidden);
    document.addEventListener('visibilitychange', this.zichtbaarheid);

    this.start();
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.zichtbaarheid);
  }

  start() {
    this.stop();
    this.timer = setInterval(() => this.volgende(), this.interval);
  }

  stop() {
    clearInterval(this.timer);
  }

  pauzeer(aan) {
    this.gepauzeerd = aan;
    if (aan) this.stop();
    else this.start();
  }

  volgende() {
    if (this.gepauzeerd) return;
    const vorige = this.meldingen[this.huidige];
    this.huidige = (this.huidige + 1) % this.meldingen.length;
    const nieuwe = this.meldingen[this.huidige];

    vorige.removeAttribute('data-actief');
    vorige.setAttribute('aria-hidden', 'true');
    nieuwe.setAttribute('data-actief', '');
    nieuwe.removeAttribute('aria-hidden');
  }
}

if (!customElements.get('flux-mededelingen')) {
  customElements.define('flux-mededelingen', FluxMededelingen);
}
